import React from 'react'
import PropTypes from 'prop-types'
import { Box, Disclosure, Text } from '@deseretbook/react-ui'
import { withCheckout } from '../CheckoutContext'
import GiftCardPaymentMethod from './GiftCardPaymentMethod'
import PlatinumPointsPaymentMethod from './PlatinumPointsPaymentMethod'
import PlatinumPointsValue from '../../PlatinumPointsValue'

/**
 * Additional payment step related actions and addons. This is where users can add gift card, promo
 * codes, and platinum points.
 *
 * @param {object} params - Component params
 * @returns {function} Component
 */
const PaymentStepAddons = ({
  availablePaymentMethods,
  user,
  order,
  status,
}) => {
  const giftCardPaymentMethod = availablePaymentMethods
    .filter(({ type }) => type === 'DeseretBook::PaymentMethod::GiftCard')[0]

  return (
    <Box maxWidth={20} paddingTop={2} paddingBottom={2}>
      {/* Gift Card / Promotion Payment */}
      <Disclosure isDisabled={status.isLoading}>
        <Disclosure.Header>
          {
            giftCardPaymentMethod
              ? 'Apply gift card or promo code'
              : 'Apply promo code'
          }
        </Disclosure.Header>
        <Disclosure.Content>
          <GiftCardPaymentMethod
            payments={order.payments}
            availablePaymentMethods={availablePaymentMethods}
          />
        </Disclosure.Content>
      </Disclosure>

      {/* Platinum Points Payment */}
      {!!(user && user.platinum) && (
        <Disclosure isDisabled={status.isLoading}>
          <Disclosure.Header>Apply Platinum Points</Disclosure.Header>
          <Disclosure.StaticContent>
            {({ isOpen }) => !isOpen && (
              <Text>
                You have <PlatinumPointsValue points={user.points} /> in points
              </Text>
            )}
          </Disclosure.StaticContent>
          <Disclosure.Content>
            <PlatinumPointsPaymentMethod
              payments={order.payments}
              availablePaymentMethods={availablePaymentMethods}
            />
          </Disclosure.Content>
        </Disclosure>
      )}
    </Box>
  )
}

PaymentStepAddons.propTypes = {
  order: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}),
  availablePaymentMethods: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
  })),
  status: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.objectOf(PropTypes.bool),
  ])),
}

PaymentStepAddons.defaultProps = {
  user: undefined,
  availablePaymentMethods: [],
  status: {},
}

export default withCheckout(PaymentStepAddons)
